import { render, staticRenderFns } from "./booking_monthly_view_tbn.vue?vue&type=template&id=15b1b012&scoped=true&"
import script from "./booking_monthly_view_tbn.vue?vue&type=script&lang=js&"
export * from "./booking_monthly_view_tbn.vue?vue&type=script&lang=js&"
import style0 from "./booking_monthly_view_tbn.vue?vue&type=style&index=0&id=15b1b012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1b012",
  null
  
)

export default component.exports